import * as React from 'react';
import {useEffect} from 'react';
import {styled, useTheme} from '@mui/material/styles';
import Box from '@mui/material/Box';
import MuiDrawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import CssBaseline from '@mui/material/CssBaseline';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import logo from "../assets/logos/logo-bi.png";
import logo_circle from "../assets/logos/logo-bi-circle_v2.png";
import {alpha, Badge, Chip, Stack} from "@mui/material";
import {NavLink, useParams} from "react-router-dom";
import useAxios from "axios-hooks";
import TourService from "../services/tour.service";
import {Groups3, Insights, Restaurant, Settings, Tour} from "@mui/icons-material";
import LogoutComponent from "./LogoutComponent";
import AccountInfo from "./AccountInfo";
import {sticketTheme} from "../theme/sticketTheme";
import {useTourStore} from "../stores/TourStore";
import dayjs from "dayjs";

let pages = [
    {id: 'overview',label: 'Overview Pasti', icon: <Restaurant/>, path: '/'},
    {id: 'reports',label: 'Reports', icon: <Insights/>, path: '/reports'},
    {id: 'users',label: 'Utenti', icon: <Groups3/>, path: '/users'},
    {id: 'settings',label: 'Settings', icon: <Settings/>, path: '/settings'}
];

const drawerWidth = 240;

const openedMixin = (theme) => ({
    width: drawerWidth,
    transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
    }),
    overflowX: 'hidden',
    background: theme.palette.primary.main,
});

const closedMixin = (theme) => ({
    transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: 'hidden',
    background: theme.palette.primary.main,
    width: `calc(${theme.spacing(7)} + 1px)`,
    [theme.breakpoints.up('sm')]: {
        width: `calc(${theme.spacing(8)} + 1px)`,
    },
});

const DrawerHeader = styled('div')(({theme}) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
}));

const Drawer = styled(MuiDrawer, {shouldForwardProp: (prop) => prop !== 'open'})(
    ({theme, open}) => ({
        width: drawerWidth,
        flexShrink: 0,
        whiteSpace: 'nowrap',
        boxSizing: 'border-box',
        ...(open && {
            ...openedMixin(theme),
            '& .MuiDrawer-paper': openedMixin(theme),
        }),
        ...(!open && {
            ...closedMixin(theme),
            '& .MuiDrawer-paper': closedMixin(theme),
        }),
    }),
);

const CustomDrawer = ({children}) => {
    const {tour_id} = useParams()

    const [{data: tour, loading: loadingTour, error: errorTour}, fetchTour] = useAxios(
        TourService.tourDataUrl(tour_id), {method: "GET", useCache: false, manual: false}
    )

    const theme = useTheme();
    const [open, setOpen] = React.useState(false);

    const handleDrawerOpen = () => {
        setOpen(true);
    };

    const handleDrawerClose = () => {
        setOpen(false);
    };

    useEffect(() => {
        if(tour) {
            useTourStore.setState((prev) => ({
                ...prev,
                ...tour
            }))
        }
    }, [tour])

    let interval
    useEffect(() => {
        function handleFetchTour() {
            console.log("handleFetchTour")
            fetchTour()
        }

        interval = setInterval(handleFetchTour, 1800000); //3600000, 1h

        return () => clearInterval(interval);
    }, [])


    return (
        <Box sx={{display: 'flex'}}>
            <CssBaseline/>
            <Drawer variant="permanent" open={open}>
                <DrawerHeader>
                    {open &&
                        <Box display={'flex'} justifyContent={'center'}>
                            <img src={logo} width={'80%'}/>
                        </Box>}
                    <IconButton onClick={open ? handleDrawerClose : handleDrawerOpen}>
                        {theme.direction === 'rtl' ? <ChevronRightIcon/> : <ChevronLeftIcon/>}
                    </IconButton>
                </DrawerHeader>
                <Divider/>
                {open && <AccountInfo/>}
                {open && <Divider sx={{background: alpha(sticketTheme.palette.secondary.main, 0.5)}}/>}
                <List sx={{marginTop: '10%'}}>
                    {pages.map((page, index) => (
                            <NavLink key={index}
                                     to={`/${tour_id}${page.path}`}
                                     style={{
                                         color: 'transparent',
                                     }}
                            >
                                {({isActive, isPending}) => (
                                    <Box mb={0.6} paddingX={1}>
                                        <ListItem key={page.id} disablePadding sx={{
                                            display: 'block',
                                            borderRadius: '2rem',
                                            background: isActive ? theme.palette.accent.main : 'inherit',
                                        }}>
                                            <ListItemButton
                                                sx={{
                                                    color: isActive ? theme.palette.primary.main : theme.palette.accent.main,
                                                    maxHeight: 42,
                                                    justifyContent: open ? 'initial' : 'center',
                                                    px: 2.5,
                                                }}
                                            >
                                                <ListItemIcon
                                                    sx={{
                                                        color: isActive ? theme.palette.primary.main : theme.palette.secondary.main,
                                                        minWidth: 0,
                                                        mr: open ? 3 : 'auto',
                                                        justifyContent: 'center',
                                                    }}
                                                >
                                                    {page.icon}
                                                </ListItemIcon>
                                                <ListItemText primary={page.label} sx={{opacity: open ? 1 : 0}}/>
                                            </ListItemButton>
                                        </ListItem>
                                    </Box>
                                )}
                            </NavLink>
                        ))}
                </List>
                <Stack marginTop={'auto'} direction={'row'} flexWrap={'wrap'}
                       justifyContent={'center'} alignItems={'center'}>
                    <Box display={'flex'} justifyContent={'center'} >
                        {!open && <img src={logo_circle} width={'90%'}/>}
                    </Box>
                    {
                        open && <Typography sx={{color: alpha(theme.palette.accent.main, 0.6), marginRight: '4px'}}
                                    textAlign={'center'}
                                    variant={'caption'}>
                            {`Versione`}
                        </Typography>
                    }
                    <Typography sx={{color: alpha(theme.palette.accent.main, 0.6), marginTop: '4px'}}
                                textAlign={'center'}
                                variant={'caption'}
                    >
                        {'1.0.0'}
                    </Typography>
                </Stack>
                <Stack mb={2} alignItems={'center'}>
                    <LogoutComponent/>
                </Stack>
            </Drawer>
            <Box component="main" sx={{flexGrow: 1, p: 3}}>
                <Stack mb={2} alignItems={'start'}>
                    <Typography variant={'h4'} fontWeight={'bold'}>{tour?.name}</Typography>
                    <Typography gutterBottom>{new Date(tour?.start_date).toLocaleDateString()} - {new Date(tour?.end_date).toLocaleDateString()}</Typography>
                    <Stack direction={'row'} alignItems={"center"} spacing={3}>
                        {tour?.current_date ?
                            <Badge badgeContent={<Stack direction={'row'} alignItems={'center'}>
                            {tour?.tot_meals_by_tour_date}
                            <Restaurant sx={{fontSize: 15}}/>
                        </Stack>} max={99999} color={'primary'}>
                            <Chip
                                label={`${tour?.current_date?.name}: ${dayjs(tour?.current_date?.start_date).format('DD/MM')} 
                        - ${dayjs(tour?.current_date?.end_date).format('DD/MM')}`}
                                icon={<Tour/>}
                                color={"secondary"}
                                //size={'small'}
                            />
                        </Badge> : null}
                        <Chip label={`Pasti totali tour: ${tour?.tot_meals}`}
                              variant={'outlined'}
                              //sx={{fontWeight: 'bold'}}
                              //color={"primary"}
                              //size={'small'}
                              deleteIcon={<Restaurant/>}
                              onDelete={() => {}}
                        />
                    </Stack>
                </Stack>
                {children}
            </Box>
        </Box>
    );
}

export default CustomDrawer